import {Injectable} from '@angular/core';
import {LoginResponse} from '../../data/loginResponse';
import {AppService} from '../../../app-common/services/app/app.service';
import {ApiService} from '../../../app-common/services/server/api.service';
import decode from 'jwt-decode';
import {AppStateService, AppWindowState} from '../../../app-common/services/appState/app-state.service';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';
import {LoginRequest} from '../../data/loginRequest';
import {RegisterTrialRequest} from '../../data/registerTrialRequest';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  jwtToken: string;

  get isLoggedIn(): boolean {
    return this.jwtToken != null;
  }

  constructor(private appService: AppService,
              private appStateService: AppStateService,
              private apiService: ApiService,
              private loggerService: LoggerService) {

    this.jwtToken = localStorage.getItem('jwtToken');
    if (this.jwtToken) {
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.AuthService, 'Token found in local storage');
    } else {
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.AuthService, 'No token found in local storage');
    }
    setTimeout(async () => {
      if (this.jwtToken) {
        await this.initializeAccount();
      }
    }, 0);
  }

  decodeToken(token: string) {
    return decode(token) as any;
  }

  async login(username: string, password: string) {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.AuthService, 'Logging in');
    try {
      const response = await this.apiService.accountApiClient.postWithPD<LoginRequest, LoginResponse>('Identity/Login', {username, password});
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.AuthService, 'Login request successful');
      this.jwtToken = response.token;
      this.appService.showSuccessMessage('Login successful');
      await this.initializeAccount();
      this.storeToken(this.jwtToken);
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.AuthService, 'After-Login successful');
      return true;
    } catch (e) {
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.AuthService, {
        entity: e,
        message: 'Login request failed.'
      });
      throw e;
    }
  }

  async registerTrial(user: RegisterTrialRequest) {
    const response = await this.apiService.accountApiClient.postWithPD<RegisterTrialRequest, undefined>('Identity/RegisterTrial', user);
    return response;
  }

  async sendPasswordResetEmail(email: string) {
    await this.apiService.accountApiClient.postWithPD('Identity/ForgotPassword', {email});
    this.appService.showSuccessMessage('Password reset email sent successfully.');
  }


  private initializeAccount() {
    this.appStateService.appWindowState = AppWindowState.Tenant;
  }

  private storeToken(jwtToken: string) {
    localStorage.setItem('jwtToken', jwtToken);
  }

  logout() {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.AuthService, 'Logging out');
    this.jwtToken = null;
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('tenantDto');
    this.appStateService.appWindowState = AppWindowState.Login;
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.AuthService, 'Logged out');
  }


}

